import { SelectProps } from 'antd';
import { PermissionsEnum, RoleOutput } from 'gql/types';
import { FormItem } from 'modules/common/components';
import RegionSelect from 'modules/locations/components/RegionSelect';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { FC } from 'react';
import { UseControllerProps } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type ProductRegionSelectProps = {
  control: Omit<UseControllerProps<any>, 'name'>;
  disabled: boolean;
  userRole: RoleOutput;
  error?: string;
  onRegionChange?: (newRegionId: string | null) => void;
} & SelectProps;

const ProductRegionSelect: FC<ProductRegionSelectProps> = ({
  control,
  disabled,
  userRole,
  onRegionChange,
  ...restProps
}) => {
  const { t } = useTranslation('admin.EditUserForm');

  const user = useCurrentUser();

  const isAllowToUpdate = user.isCan(
    PermissionsEnum.UpdateProductLocationPreference
  );

  return (
    <FormItem label={t('productRegionPreference')}>
      <RegionSelect
        {...restProps}
        controlled={{
          ...control,
          name: 'productRegionPreference',
        }}
        disabled={disabled || !isAllowToUpdate}
        onRegionChange={onRegionChange}
      />
    </FormItem>
  );
};

export default ProductRegionSelect;
